import React from 'react';
import { IProps } from './types';
import _ from 'lodash';
import { SysOption } from 'bff/models/info';
import commonService from 'utils/commonService';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';

const Download: React.FC<IProps> = (props) => {
  /**
   * @description 產生下載內容區塊
  */
  const handleCreateContent = (sysOpts:SysOption[]) => {
    if (sysOpts.length === 0) return;

    return _.map(sysOpts, (sysOpt:SysOption, index:number) => (
      <button
        key={index}
        type="button"
        className="download__btn"
        onClick={() => {
          try {
            commonService.downloadFile(sysOpt.PARAM_VALUE, '');
          } catch {
            sweetAlertService.modal({
              icon: SweetAlertIcon.Info,
              title: '下載失敗',
              html: '無法取得相關資訊'
            });
          }
        }}
      >
        {sysOpt.PARAM_TEXT}
      </button>
    ));
  };

  return (
    <div className="download">
      <div className="template-container">
        <div className="template-content">
          <div className="download__title-section">
            <div className="download__title">軟體下載</div>
          </div>
          <div className="download__content">
            <div className="download__items-section">
              <div className="download__items-section-title">下載TWCA程式</div>
              <div className="download__items-section-content">
                {handleCreateContent(props.twcaSWSysOpts)}
              </div>
            </div>
            <div className="download__items-section">
              <div className="download__items-section-title">下載TWCA手冊</div>
              <div className="download__items-section-content">
                {handleCreateContent(props.twcaUGSysOpts)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Download;
